class Hmac {
  constructor({
    /*: {
        id: ?string,
        name: ?string,
        propertyId: ?string,
        businessId: ?string,
        secret: ?string
      }*/

    id,
    name,
    propertyId,
    businessId,
    secret
  }) {
    this.id = id;
    this.name = name;
    this.propertyId = propertyId;
    this.businessId = businessId;
    this.secret = secret;
  }

}

module.exports = Hmac;